import CombinedLobbyPages from "../Lobby/index.jsx";
import Header from "../components/Header";
import {useSelector} from "react-redux";
import PageWrapper from "../Lobby/PageWrapper/PageWrapper";
import React, {useMemo} from "react";
import Room from "../components/Room";
import GameModal from "../components/Modals/index.jsx";
import {handleStyles} from "../../utils/index.js";
import SafeDynamicComponent from "../components/SafeDynamicComponent.jsx";
import HistoryRoom from "../components/HistoryRoom/HistoryRoom.jsx";
import Maintenance from "../components/Maintenance/Maintenance.jsx";

const Main = React.memo(function () {
    const {activePage, activeRoomId, maintenance} = useSelector(state => state.lobby);
    const rooms = useSelector(state => state.rooms) || {};
    const MemoizedLobbyActivePage = useMemo(() => {
        if (maintenance.includes(activePage)) {
            return () => <Maintenance activePage={activePage}/>;
        }
        return CombinedLobbyPages[activePage];
    }, [activePage, maintenance]);
    let board = handleStyles("board", 3);
    let frontCard = handleStyles("card-front", 2);
    let backCard = handleStyles("card-back", 4);
    const {selectedRoomId} = useSelector(state => state.history);

    const roomComponents = Object.values(rooms).map((room, index) => {
        if (room.historyRoomPlayer) return;
        return (
            <Room
                key={room?.roomId}
                roomId={room.roomId}
                isActive={Number(activeRoomId) === Number(room?.roomId)}
            />
        )
    });

    return (
        <div className={`belote-wrapper board-V${board} card-back-V${backCard} card-front-V${frontCard}`}>
            <GameModal/>
            <Header/>
            <PageWrapper page={activePage}>
                <SafeDynamicComponent Component={MemoizedLobbyActivePage}/>
            </PageWrapper>
            {roomComponents}
            {rooms?.[selectedRoomId] &&
                <HistoryRoom
                    isActive={Number(activeRoomId) === Number(selectedRoomId)}
                />
            }
        </div>
    );
});

export default Main;
